import React from "react";

export function TextHeader(props) {
  return <h1>{props.header}</h1>}

export function TextSubHeader(props) {
  return <h2>{props.subheader}</h2>}

export function TextDescription(props) {
  return <h3>{props.description}</h3>}